import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import TaskIcon from "@mui/icons-material/Task";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import PeopleIcon from "@mui/icons-material/People";
import LogoutButton from "../../components/LogoutButton/LogoutButton";
import { useDistributor } from "../../hooks/useDistributor";
import { useDistributorAuth } from "../../context/DistributorAuthContext";
import { SidebarHeader } from "../../components/SidebarHeader";
import IMGlogo from "../../assets/imagine-logo.png";
import { AuthContext } from "../../context/AuthContext";
import { menuClasses } from "react-pro-sidebar";
import { Avatar, Typography } from "@mui/material";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import useAuth from "../../context/useAuth";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';


const themes = {
  light: {
    sidebar: {
      backgroundColor:
        "linear-gradient( to bottom,rgba(255, 0, 0, 0) 0%,rgba(255, 0, 0, 0.5) 40%,rgba(255, 0, 0, 0.8) 60%,red 100%);",
      color: "#607489",
    },
    menu: {
      menuContent: "white",
      icon: "white",
      hover: {
        backgroundColor: "#000000",
        color: "#f20014",
      },
      disabled: {
        color: "#f20014",
      },
    },
  },
  dark: {
    sidebar: {
      backgroundColor:
        "linear-gradient( to bottom,rgba(255, 0, 0, 0) 0%,rgba(255, 0, 0, 0.5) 40%,rgba(255, 0, 0, 0.8) 60%,red 100%);",
      color: "#8ba1b7",
    },
    menu: {
      menuContent: "white",
      icon: "#white",
      hover: {
        backgroundColor: "#ffffff",
        color: "#f20014",
      },
      disabled: {
        color: "#f20014",
      },
    },
  },
};

const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const DistributorTheme = ({ content }) => {
  return (
    <div className="w-full h-[98.3vh] flex text-white Maindiv-mc">
      <SideMenu />
      <div className="w-full">
        <div className="slog-mc pt-8">
          <p className="text-right text-2xl">
            INNOVATION | ENTERTAINMENT | SUSTAINABILITY
          </p>
          <Nav />
        </div>

        <div className="d-content-mc">
          <div className="d-data-mc">{content}</div>
        </div>
      </div>
    </div>
  );
};

const SideMenu = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [rtl] = useState(false);
  const [hasImage] = useState(true);
  const [theme] = useState("light");
  const { logoutDistributor } = useDistributorAuth();
  const navigate = useNavigate();
  const distributor = useDistributor(); // Always call hooks at the top
  const { role } = useContext(AuthContext);


  // Handle logout
  const handleLogout = async () => {
    logoutDistributor();
    navigate("/distributor/login");
  };

  const menuItemStyles = {
    root: {
      fontSize: "13px",
      fontWeight: 400,
    },
    icon: {
      color: themes[theme].menu.icon,
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
    },
    SubMenuExpandIcon: {
      color: "#b6b7b9",
    },
    subMenuContent: ({ level }) => ({
      backgroundColor:
        level === 0
          ? hexToRgba(
              themes[theme].menu.menuContent,
              hasImage && !collapsed ? 0.4 : 1
            )
          : "transparent",
    }),
    button: {
      [`&.${menuClasses.disabled}`]: {
        color: themes[theme].menu.disabled.color,
      },
      "&:hover": {
        backgroundColor: hexToRgba(
          themes[theme].menu.hover.backgroundColor,
          hasImage ? 0.8 : 1
        ),
        color: themes[theme].menu.hover.color,
      },
    },
    label: ({ open }) => ({
      fontWeight: open ? 600 : undefined,
    }),
  };

  // Ensure that if distributor is not available, the component doesn't render any menu
  if (!distributor) {
    return null; // Or show a loading spinner or redirect to login page
  }

  return (
    <Sidebar
      collapsed={collapsed}
      toggled={toggled}
      onBackdropClick={() => setToggled(false)}
      breakPoint="md"
      rootStyles={{
        color: themes[theme].sidebar.color,
      }}
      backgroundColor={
        "linear-gradient( to bottom,rgba(255, 0, 0, 0) 0%,rgba(255, 0, 0, 0.5) 40%,rgba(255, 0, 0, 0.8) 60%,red 100%)"
      }
    >
      <div className="flex flex-col h-full">
        <SidebarHeader rtl={rtl} className="mb-6 mt-4" />
        <div className="flex-1 mb-8">
          <Menu menuItemStyles={menuItemStyles}>
            {/* Render distributor info only if it's available */}
            <MenuItem
              icon={
                <img
                  src={`https://avatar.iran.liara.run/username?username=${distributor.userName}`}
                  alt="role"
                />
              }
              className="mb-10 mt-[0px]"
            >
              <span>{distributor.userName} - {distributor.role}</span>
            </MenuItem>

            <MenuItem
              onClick={() => navigate("/distributor/stats")}
              icon={<DashboardIcon />}
            >
              Dashboard
            </MenuItem>

            <SubMenu label="Inventory" icon={<InventoryIcon />}>
              <MenuItem onClick={() => navigate("/distributor/inventory")}>
                All Inventory
              </MenuItem>
            </SubMenu>

            <MenuItem
              onClick={() => navigate("/distributor/transaction")}
              icon={<TaskIcon />}
            >
              Transactions
            </MenuItem>


{distributor.role.toLowerCase()=='retailer' ?<></>: <SubMenu label="Manage Users" icon={<PeopleIcon />}>
              <MenuItem
                onClick={() => navigate("/distributor/show-retaillers")}
              >
                Retailers
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/distributor/create-retaillor")}
              >
                Create Retailer
              </MenuItem>
            </SubMenu>} 
            
            {distributor.role.toLowerCase()=='retailer' ?<></>:
            <MenuItem
              onClick={() => navigate("/distributor/billing")}
              icon={<ReceiptLongIcon />}
            >
              Billing
            </MenuItem>
}
            <MenuItem
              onClick={() => navigate("/distributor/ProductDetails")}
              icon={<PhoneIphoneIcon />}
            >
              Search Product
            </MenuItem>

            <MenuItem onClick={()=>navigate("/all-brands")} icon={<ShoppingBagIcon />}>
              Imagine Stock
            </MenuItem>
            <MenuItem onClick={handleLogout} icon={<LogoutButton />}>
              Log Out
            </MenuItem>

            <MenuItem
              onClick={() => setCollapsed(!collapsed)}
              icon={collapsed ? <ClearAllIcon /> : <CloseIcon />}
            >
              {!collapsed && "Collapsed"}
            </MenuItem>


{/* conditional rendering  */}
  {role.toLowerCase()==='admin' &&    <MenuItem onClick={()=>{navigate('/all-retailer')}} icon={<ReplyAllIcon />}>
             Back To Admin
            </MenuItem>}
         


          </Menu>
        </div>
      </div>
    </Sidebar>
  );
};

const Nav = () => {
  return (
    <div className="Nav-mc bg-gradient-to-r from-transparent via-transparent to-red-700 flex justify-between items-center">
      <img src={IMGlogo} alt="Logo" className="w-80 mt-[-20px]" />
      <span className="text-3xl mr-5">Let's be the change</span>
    </div>
  );
};

export default DistributorTheme;
